import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { Formik, Form } from 'formik';
import { decodeJwt } from '../../../shared/utils/functions/decodeJwt/decodeJwt.js';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import { useViewContext } from '../../../context/ViewContext/ViewContext.js';
import '../../../utils/constants/colors.js';
import '../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../context/DynamicContext/useInternalDynamicContext.js';
import '@dynamic-labs/sdk-api';
import '../../../components/ShadowDOM/ShadowDOM.js';
import '../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../config/ApiEndpoint.js';
import '../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../context/MockContext/MockContext.js';
import '../../../context/CaptchaContext/CaptchaContext.js';
import { useUserUpdateRequestInternal } from '../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../../components/Button/Button.js';
import '../../../components/IconButton/IconButton.js';
import { UserDataFields } from '../UserDataFields/index.js';
import { useUserDataForm } from '../../../utils/hooks/useUserDataForm/useUserDataForm.js';

const UserDataForm = ({ children, userProfile }) => {
    const { policiesConsentInnerComponent, onboardingOnlyJwt, setShowAuthFlow, setCallback, } = useInternalDynamicContext();
    const { setView } = useViewContext();
    const decodedJwt = decodeJwt(onboardingOnlyJwt);
    const { updateUser } = useUserUpdateRequestInternal({
        validationSchemaStripUnknown: false,
    });
    const onSubmit = useCallback((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        const { isEmailVerificationRequired } = yield updateUser(formValues);
        if (isEmailVerificationRequired) {
            setView('verify-email');
            return;
        }
        setShowAuthFlow(false);
        setCallback('authSuccess');
    }), [setCallback, setShowAuthFlow, setView, updateUser]);
    const { fetch: loading, formikInitialValues, formikValidationSchema, enforcePolicies, onFormSubmit, } = useUserDataForm({
        fields: (decodedJwt === null || decodedJwt === void 0 ? void 0 : decodedJwt.missingFields) || [],
        onSubmit,
        userProfile,
    });
    const policiesConsentInnerComponentArray = [
        policiesConsentInnerComponent,
    ].flat();
    return (jsx(Formik, Object.assign({ onSubmit: onFormSubmit, initialValues: formikInitialValues, validationSchema: formikValidationSchema }, { children: ({ errors, touched, values }) => {
            var _a;
            const isSubmitBtnDisabled = enforcePolicies &&
                (policiesConsentInnerComponentArray === null || policiesConsentInnerComponentArray === void 0 ? void 0 : policiesConsentInnerComponentArray.length) !==
                    ((_a = values.policiesConsentArray) === null || _a === void 0 ? void 0 : _a.length);
            return (jsx(Form, Object.assign({ className: 'user-data-form__form' }, { children: jsxs(Fragment, { children: [children, jsx(UserDataFields, { fields: decodedJwt === null || decodedJwt === void 0 ? void 0 : decodedJwt.missingFields, errors: errors, touched: touched, policiesConsentInnerComponentArray: policiesConsentInnerComponentArray }), jsx(Button, Object.assign({ type: 'submit', loading: loading, disabled: isSubmitBtnDisabled, buttonVariant: 'primary', expanded: true, buttonRounded: 'default', buttonPadding: 'large' }, { children: "Continue" }))] }) })));
        } })));
};

export { UserDataForm };
